module.exports = __webpack_public_path__ + "img/TMDB_logo.08392f18.svg";